import { defineMessages } from "react-intl"

const messages = defineMessages({
  browser: {
	id: "audio.browser",
	defaultMessage: "Sorry, your browser does not support the audio element."
  }
})

export default messages


// WEBPACK FOOTER //
// ./webapp/messages/audio.js